
import api from '@/api'

export default {
    /**
     * 통합 검색 전자결재 , 게시판, 조직도
     * @param data 
     * @returns 
     */
    totalSearch: (data:gnbTotalSearch.TotalSearchRequest) :   Promise<gnbTotalSearch.TotalSearchResponse> => {
        
        return api.post({
            url: '/api/isu/totalsearch',
            data: data,
        })
    },
}

 



// 